import { Route, Routes } from "react-router-dom";
import "./App.css";
import "./index.css";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import About_Us from "./components/about-us/About_Us";
import Contact_Us from "./components/contact-us/Contact_Us";
import TermsConditions from "./components/terms-conditions/Terms_Conditions";
import PrivacyPolicy from "./components/privacy-policy/Privacy_Policy";
import ScrollToTop from "./components/common-components/scroll-to-top/Scroll_To_Top";
function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<About_Us />} />
        <Route path="/contactus" element={<Contact_Us />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
